module.exports = __webpack_public_path__ + "static/img/img-20.b15d7de.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img-20.png
// module id = lpnp
// module chunks = 1